// src/Components/Forms/TypeFinancement/Salam/Tab3.tsx
import React from 'react';
import { Box, Grid } from '@mui/material';
import SelectMultipleOptionPanier from '../../../SelectMultipleOptionPanier';
import ParamsPicklist from '../../../../Types/ParamsPicklist';

// Paramètres pour chaque picklist
let searchFinancement: ParamsPicklist = {
  CodeAgence: '',
  Table: "TypeGarantie",
  Colonne1: "CodeTypeGarantie",
  Colonne2: "LibelleGarantie",
  Colagence: '101',
  Choix: 22
};

let searchPlancp: ParamsPicklist = { CodeAgence: '', Table: "PLANCP", Colonne1: "IDPLAN", Colonne2: "LIBELL",Colagence: "", Choix: 39,tablelength:'societe',collength:'LenPlancp' }
  
let searchCategorieActif: ParamsPicklist = {
  CodeAgence: '',
  Table: "CategorieActif",
  Colonne1: "CodeCategorie",
  Colonne2: "Libelle",
  Colagence: '101',
  Choix: 22
};

let searchOperat: ParamsPicklist = {
  CodeAgence: '',
  Table: "OPERAT",
  Colonne1: "CODOPE",
  Colonne2: "LIBELL",
  Colagence: '101',
  Choix: 22
};


interface Tab3Props {
  form?: any;
}

const Tab3 = (props: Tab3Props) => {
  return (
    <div className="tabItem">
      <Box fontStyle="inherit" className="border" width={"85%"} position={"absolute"}>
        <Grid container spacing={0}>
          {/* Garanties */}
          <Grid item xs={12} md={6}>
            <SelectMultipleOptionPanier
              form={props.form}
              Size="large"
              width={4}
              label="Garanties autorisées"
              name="TypeGarantieAuto"
              Parametre={searchFinancement}
            />
          </Grid>
          {/* Actifs */}
          <Grid item xs={12} md={6}>
            <SelectMultipleOptionPanier
              form={props.form}
              Size="large"
              width={4}
              notRequired
              label="Categorie d'actif"
              name="CategorieActifsSalam"
              Parametre={searchCategorieActif}
            />
          </Grid>
          {/* Frais autorisés */}
          <Grid item xs={12} md={6}>
            <SelectMultipleOptionPanier
              form={props.form}
              width={4}
              Size="large"
              label="Frais services autorisés"
              name="FraisAutorise"
              Parametre={searchOperat}
            />
          </Grid>
          {/* Remises auutorisees */}
          <Grid item xs={12} md={6}>
            <SelectMultipleOptionPanier
              form={props.form}
              Size="large"
              width={7}
              label="Plan remboursement autorisé"
              name="RemAuto"
              Parametre={searchPlancp}
            />
          </Grid>
          {/* Fournisseurs autorisees */}
        
        </Grid>
      </Box>
    </div>
  );
};

export default Tab3;